"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INPUT_ITEM_TYPE = void 0;
exports.INPUT_ITEM_TYPE = {
    mailAddressFree: 'mailAddressFree',
    mailAddressAtSignSeparated: 'mailAddressAtSignSeparated',
    mailAddressDomainPulldown: 'mailAddressDomainPulldown',
    textSingleLine: 'textSingleLine',
    textName: 'textName',
    textTel: 'textTel',
    textAdditionalText: 'textAdditionalText',
    textMultiLine: 'textMultiLine',
    textZipCode: 'textZipCode',
    textZipCodeWithoutHyphen: 'textZipCodeWithoutHyphen',
    numberAdditionalText: 'numberAdditionalText',
    numberAttitudeScale: 'numberAttitudeScale',
    dateFree: 'dateFree',
    dateYearPulldown: 'dateYearPulldown',
    monthDayPulldown: 'monthDayPulldown',
    monthDayFree: 'monthDayFree',
    singleSelectionPulldown: 'singleSelectionPulldown',
    singleSelectionRadio: 'singleSelectionRadio',
    multipleSelectionCheckbox: 'multipleSelectionCheckbox',
    mailRefusalFlagRadio: 'mailRefusalFlagRadio',
    passwordHashText: 'passwordHashText',
    fileUploadPiclib: 'fileUploadPiclib',
};
